export enum Home {
  title = 'home.title',
  sendToFriend = 'home.sendToFriend',
}
